import { useCallback, useState } from 'react'

import { PhotosUploader } from '@app/services/loaderManagerService/loaders'
import { S3Error } from '@app/utils/s3ErrorHandler'

import notificationService from '@app/services/notificationService'

interface UsePhotosUploadParams {
  taskId: string | number
  onPhotosUploadFinish?: () => void
}

interface UsePhotosUploadReturn {
  percent: number
  isUploading: boolean
  upload: (files: File[]) => void
}

export const usePhotosUpload = ({ taskId, onPhotosUploadFinish }: UsePhotosUploadParams): UsePhotosUploadReturn => {
  const [isUploading, setIsUploading] = useState(false)
  const [percent, setPercent] = useState(0)

  const upload = useCallback(
    (files: File[]): void => {
      setIsUploading(true)

      const photosUploader = new PhotosUploader(taskId, files)

      photosUploader.onError(loader => {
        const error = loader.error
        let description = 'Что-то пошло не так при загрузке фото.'

        if (error instanceof S3Error) {
          description = error.details.userMessage
        } else if (error instanceof Error) {
          description = error.message
        }

        notificationService.error({
          message: 'Ошибка:',
          description,
          duration: 0
        })
      })

      photosUploader.onSuccess(() =>
        notificationService.success({
          message: 'Успех:',
          description: 'Все фото загрузились успешно.'
        })
      )

      photosUploader.onComplete(() => {
        setIsUploading(false)
        setPercent(0)

        onPhotosUploadFinish?.()
      })

      photosUploader.onProgress(({ percent }): void => {
        percent && setPercent(percent)
      })

      photosUploader.start()
    },
    [taskId]
  )

  return {
    isUploading,
    percent,
    upload
  }
}
